import ContentContainer from "@/components/layout/ContentContainer.tsx";
import {ErrorFallback} from "@/lib/handlers/ErrorFallback.tsx";
import {UpErrorBoundary} from "@/lib/handlers/UpErrorBoundary.tsx";
import {CheckDetailsContent} from "@/pages/checks/analysis/CheckDetailsContent.tsx";

export const CheckAnalysis = () => (
  <UpErrorBoundary
    fallback={
      <ContentContainer title="Check Analysis">
        <ErrorFallback />
      </ContentContainer>
    }
  >
    <CheckDetailsContent />
  </UpErrorBoundary>
);
